import { Navigate, useLocation } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
    const isAuthenticated = !!localStorage.getItem("token");
    const location = useLocation();

    const publicPaths = ["/success", "/failure"];

    if (!isAuthenticated && !publicPaths.includes(location.pathname)) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default PrivateRoute;